

























import Vue from 'vue';

import HubHeading from './HubHeading.vue';
import HubCard from './HubCard.vue';

export default Vue.extend({
  name: 'HubModal',

  components: {
    HubHeading,
    HubCard,
  },

  props: {
    close: {
      type: Boolean,
    },
    height: {
      type: [Number, String],
      default: 350,
    },
    title: {
      type: String,
      default: '',
    },
    value: {
      type: Boolean,
      required: true,
    },
    width: {
      type: [Number, String],
      default: 500,
    },
  },

  computed: {
    modalActive() {
      return this.value;
    },
  },

  methods: {
    closeModal(event: Event | undefined) {
      if (!event) {
        this.$emit('input', false);
        return;
      }

      const elClassName = (event.target as HTMLElement).className.toString();
      const regEx = /modal-mask/g;
      const isOutside = regEx.test(elClassName);

      if (isOutside) {
        this.$emit('input', false);
      }
    },
  },
});
